import { render, staticRenderFns } from "./MemberUid.vue?vue&type=template&id=44c11d27&scoped=true"
import script from "./MemberUid.vue?vue&type=script&lang=js"
export * from "./MemberUid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c11d27",
  null
  
)

export default component.exports